// extracted by mini-css-extract-plugin
export default {"signIn":"O3dLS","loginButtonInner":"wutJr","loginButtonLabel":"EFHt5"};